import {
  get_datiUserInfo
} from "@/api/api.user.js";
import storage from "../../services/storage";

const user = {
  namespaced: true,

  state: {
    user: '',
    roleId: '',
    menu: [],
    compCode: null,
    compName: "",
    eMail: "",
    userId: null,
    gruppo: "",
    certificazioneFSC: "",
    certificazionePEFC: "",
    certificazionePEFCG: "",
    certificazioneFPC: "",
  },

  mutations: {
    SET_USER: (state, user) => {

      state.user = user.username
      state.roleId = user.roleId
      state.menu = user.menu
      state.compCode = user.companyCode
      state.compName = user.username
      state.eMail = user.eMail
      state.userId = user.userId
      state.gruppo = user.gruppo
      state.certificazioneFSC = user.certificazioneFSC
      state.certificazionePEFC = user.certificazionePEFC
      state.certificazionePEFCG = user.certificazionePEFCG
      state.certificazioneFPC = user.certificazioneFPC
    },

    SET_USERSWITCH: (state, data) => {
      state.compCode = data.CompCode;
      state.compName = data.CompName;
      if (data != null && data != undefined) {
        storage.setCompCode(data.CompCode)
        storage.setCompName(data.CompName)
      }
    },

    CLEAR_COMPANYDATA: (state) => {
      state.compCode = null;
      state.compName = "";
      storage.clearCompanyData()
    }

  },

  actions: {

    userInfo({
      commit,
      dispatch
    }) {

      return new Promise((resolve, reject) => {

        get_datiUserInfo().then(resp => {

          commit("SET_USER", resp.data)

          resolve(resp)

        }).catch(err => {
          storage.logout();
          reject(err)
        })
      })

    },


  },

  getters: {
    getRole: state => state.roleId,
    getTitolo: state => link => {
      let itemFind = state.menu.find(x => x.Link === link);
      if (itemFind)
        return itemFind.Text + '|' + itemFind.Img;

      return ""
    },
    getNome: state => {
      return state.user
    },
    getMail: state => {
      return state.eMail
    },
    getUserId: state => {
      return state.userId
    },
    getGruppo: state => {
      return state.gruppo
    },
    getCertificazioneFSC: state => {
      return state.certificazioneFSC
    },
    getCertificazionePEFC: state => {
      return state.certificazionePEFC
    },
    getCertificazionePEFCG: state => {
      return state.certificazionePEFCG
    },
    getCertificazioneFPC: state => {
      return state.certificazioneFPC
    },

    getCompanyCode: state => state.compCode,
    getCompanyName: state => state.compName,
  }
}


export default user